import { combineReducers } from "@reduxjs/toolkit";
import { CurrentOrganizationSlice, OrganizationSlice } from "./organization";
import { OrgRoleSlice, TenantRolesSlice } from "./roles";
import { PermissionsSlice } from "./permissions";
import { OrganizationUsersSlice, UserInvitationsSlice } from "./users";
const rootReducer = combineReducers({
  organization: OrganizationSlice.reducer,
  currentOrganization: CurrentOrganizationSlice.reducer,
  orgRoles: OrgRoleSlice.reducer,
  tenantRoles: TenantRolesSlice.reducer,
  permissions: PermissionsSlice.reducer,
  orgUsers: OrganizationUsersSlice.reducer,
  orgUserInvitations: UserInvitationsSlice.reducer
});

export default rootReducer;
